import { useEffect, useState } from 'react';
import { siteConfigApi, SiteConfig } from '@/lib/api';

// Module-level promise cache: PromoBar and Footer both mount on every page (and
// some pages add a third caller), which fired /site-config two or three times
// per page load. One request per page load now, shared by every consumer.
// A failed fetch clears the cache so a later mount can retry.
// (Same pattern as useSiteMenus / useMegaMenu.)
let configPromise: Promise<SiteConfig | null> | null = null;

function loadConfig(): Promise<SiteConfig | null> {
  if (!configPromise) {
    configPromise = siteConfigApi
      .get()
      .then((res) => res.data ?? null)
      .catch(() => {
        configPromise = null;
        return null;
      });
  }
  return configPromise;
}

/**
 * Admin-managed public site config (promo bar, SP registration links, …).
 * Returns null until loaded and on failure — callers keep their fallbacks so
 * the chrome never renders empty.
 */
export function useSiteConfig(): SiteConfig | null {
  const [config, setConfig] = useState<SiteConfig | null>(null);

  useEffect(() => {
    let cancelled = false;
    loadConfig().then((c) => {
      if (!cancelled && c) setConfig(c);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return config;
}
